import styled from "styled-components";
import {JackpotBetWidgetPCWrapperDefaultBox} from "./jackpot-bet-widget-pc-wrapper.default.box";

export const JackpotBetWidgetPCWrapperCasino777Box = styled(JackpotBetWidgetPCWrapperDefaultBox)`
    margin: 0rem 1rem 9rem 1rem;
`;
